import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Table from '../../components/table/table';
import { DataType, RowObject, Tbody } from '../../components/table/tableModels';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
// tslint:disable-next-line:no-var-requires
const moment = require('moment');

import { invoicesActionCreators } from '../../data/invoices/invoicesAction';
import { ApiInvoiceObject, ApiInvoicesState } from '../../data/invoices/invoicesModels';
import { opportunitiesActionCreators } from '../../data/opportuneties/opportunetisActions';
import { ApiOpportunitiesState, OpportunitiesObject } from '../../data/opportuneties/opportunetisModels';
import { orderActionCreators } from '../../data/order/orderActions';
import { ApiOrderObject, ApiOrderState } from '../../data/order/orderModels';
import { shipmentsActionCreators } from '../../data/shipment/shipmentAction';
import { ShipmentObject, ShipmentState } from '../../data/shipment/shipmentModels';

type SearchProps = SearchState & SearchAction & RouteComponentProps<{}>;

interface SearchState {
    shipments: ShipmentState;
    header: HeaderState;
    opportunities: ApiOpportunitiesState;
    orders: ApiOrderState;
    invoices: ApiInvoicesState;
}

interface SearchAction {
    shipmentActions: typeof shipmentsActionCreators;
    headerActions: typeof headerActionCreators;
    opportunitiesActions: typeof opportunitiesActionCreators;
    orderActions: typeof orderActionCreators;
    invoiceActions: typeof invoicesActionCreators;
}

interface State {
    searchValue: string;
    shipments: ShipmentObject[];
    opportunities: OpportunitiesObject[];
    orders: ApiOrderObject[];
    invoices: ApiInvoiceObject[];
    tableprop: {
        shipmentHead: Array<RowObject>;
        opportunityHead: Array<RowObject>;
        orderHead: Array<RowObject>;
        invoiceHead: Array<RowObject>;
    };
}

class Search extends React.Component<SearchProps, State> {
    constructor(props: SearchProps) {
        super(props);
        this.searchData = this.searchData.bind(this);

        this.state = {
            searchValue: '',
            shipments: [],
            opportunities: [],
            invoices: [],
            orders: [],
            tableprop: {
                shipmentHead: [
                    new RowObject(DataType.string, 'Shipping Date', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Order Number', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'PO Number', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Carrier', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Tracking Number', undefined, undefined, 'pointer')
                    // new RowObject(DataType.string, 'Freight Charge', undefined, undefined, 'pointer')
                ],
                invoiceHead: [
                    new RowObject(DataType.string, 'Line Number', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Item Number', undefined, undefined, 'pointer'),
                    new RowObject(DataType.number, 'Ordered Qty', undefined, undefined, 'pointer'),
                    new RowObject(DataType.number, 'Delivered Qty', undefined, undefined, 'pointer'),
                    new RowObject(DataType.number, 'Backorder Qty', undefined, undefined, 'pointer'),
                    new RowObject(DataType.number, 'Unit Price', undefined, undefined, 'pointer'),
                    new RowObject(DataType.number, 'Discount', undefined, undefined, 'pointer'),
                    new RowObject(DataType.number, 'Amount', undefined, undefined, 'pointer')
                ],
                opportunityHead: [
                    new RowObject(DataType.string, 'Name', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Company', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'City', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'State', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Email', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Date', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Topic', undefined, undefined, 'pointer')
                ],
                orderHead: [
                    new RowObject(DataType.string, 'Order Date', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Purchase Order', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Order Number', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Ship To Name', undefined, undefined, 'pointer'),
                    new RowObject(DataType.string, 'Estimated Ship Date', undefined, undefined, 'pointer')
                ]
            }
        };
    }

    setSearchData(searchValue: string) {
        this.setState({ searchValue: searchValue });
    }

    searchData() {
        let filteredShimpments: ShipmentObject[] = Array<any>();
        let filteredOpportuniteis: OpportunitiesObject[] = Array<any>();
        let filteredInvoices: ApiInvoiceObject[] = Array<any>();
        let filteredOrders: ApiOrderObject[] = Array<any>();
        if (this.state.searchValue.length > 0) {
            filteredShimpments = this.filterShipments(this.state.searchValue);
            filteredOpportuniteis = this.filterOpportunities(this.state.searchValue);
            filteredInvoices = this.filterInvoices(this.state.searchValue);
            filteredOrders = this.filterOrder(this.state.searchValue);
        }
        this.setState({
            shipments: filteredShimpments,
            invoices: filteredInvoices,
            opportunities: filteredOpportuniteis,
            orders: filteredOrders
        });
    }

    filterShipments(searchValue: string) {
        let filteredShipments: ShipmentObject[];
        filteredShipments = Array<any>();
        this.props.shipments.shipments.forEach((shipment) => {
            if (this.findInObject(shipment, searchValue)) {
                filteredShipments.push(shipment);
            }
        });
        return filteredShipments;
        // this.setState( { shipments: filteredShipments });
    }

    filterOpportunities(searchValue: string) {
        let filteredValue: OpportunitiesObject[];
        filteredValue = Array<any>();
        this.props.opportunities.opportunities.forEach((childobject) => {
            if (this.findInObject(childobject, searchValue)) {
                filteredValue.push(childobject);
            }
        });
        return filteredValue;
        // this.setState( { opportunities: filteredValue });
    }

    filterOrder(searchValue: string) {
        let filteredValue: ApiOrderObject[];
        filteredValue = Array<any>();
        this.props.orders.orders.forEach((childobject) => {
            if (this.findInObject(childobject, searchValue)) {
                filteredValue.push(childobject);
            }
        });
        return filteredValue;
    }

    filterInvoices(searchValue: string) {
        let filteredValue: ApiInvoiceObject[];
        filteredValue = Array<any>();
        this.props.invoices.invoices.forEach((childobject) => {
            if (this.findInObject(childobject, searchValue)) {
                filteredValue.push(childobject);
            }
        });
        return filteredValue;
    }

    findInObject(findObj: Object, searchValue: string) {
        let exists = false;
        Object.keys(findObj).map((obj) => {
            const value = findObj[obj] as string;
            if (
                value &&
                value !== undefined &&
                value.toString() !== undefined &&
                value.toString().toLowerCase().includes(searchValue.toLowerCase())
            ) {
                exists = true;
            }
        });
        return exists;
    }

    renderOpportunityBody() {
        return this.state.opportunities.map((data, index) => {
            const rBody = new Array<RowObject>();

            rBody.push(new RowObject(DataType.string, data.name ? data.name : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.company ? data.company : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.city ? data.city : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.state ? data.state : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.email ? data.email : '', null, undefined, undefined));

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.createdDate ? moment(data.createdDate, 'M/D/YYYY').format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );

            rBody.push(new RowObject(DataType.string, data.topic ? data.topic : '', null, undefined, undefined));
            return new Tbody(rBody, data.opportunityid, this.openOpportunity.bind(this));
        });
    }

    openOpportunity(opportunityid: string) {
        this.props.history.push('/opportunitie/' + opportunityid);
    }

    renderOrderBody() {
        return this.state.orders.map((data) => {
            const rBody = new Array<RowObject>();

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.orderDate ? moment(data.orderDate, 'M/D/YYYY').format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );

            rBody.push(
                new RowObject(DataType.string, data.purchaseOrder ? data.purchaseOrder : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(DataType.string, data.orderNumber ? data.orderNumber : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(DataType.string, data.shippingName ? data.shippingName : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.estimatedShipDate ? moment(data.estimatedShipDate).format('L') : '',
                    null,
                    undefined,
                    undefined
                )
            );
            return new Tbody(rBody, data.orderId, this.openOrder.bind(this));
        });
    }

    openOrder(orderId: string) {
        this.props.history.push('/order/' + orderId);
    }

    renderInvoiceBody() {
        return this.state.invoices.map((data) => {
            const rBody = new Array<RowObject>();

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.dueDate ? moment(data.dueDate, 'M/D/YYYY').format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );

            rBody.push(
                new RowObject(DataType.string, data.invoiceNumber ? data.invoiceNumber : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(DataType.string, data.orderNumber ? data.orderNumber : '', null, undefined, undefined)
            );

            rBody.push(new RowObject(DataType.string, data.poNumber ? data.poNumber : '', null, undefined, undefined));

            rBody.push(
                new RowObject(DataType.string, data.shiptoname ? data.shiptoname : '', null, undefined, undefined)
            );

            rBody.push(new RowObject(DataType.string, data.balance ? data.balance : '', null, undefined, undefined));
            return new Tbody(rBody, data.invoiceId, this.openInvoice.bind(this));
        });
    }

    openInvoice(orderId: string) {
        this.props.history.push('/invoice/' + orderId);
    }

    renderShipmentBody() {
        return this.state.shipments.map((data) => {
            const rBody = new Array<RowObject>();

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.shipDate ? moment(data.shipDate, 'M/D/YYYY').format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );

            rBody.push(
                new RowObject(DataType.string, data.orderNumber ? data.orderNumber : '', null, undefined, undefined)
            );

            rBody.push(new RowObject(DataType.string, data.pONumber ? data.pONumber : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.carrier ? data.carrier : '', null, undefined, undefined));

            rBody.push(
                new RowObject(DataType.string, data.trackNumber ? data.trackNumber : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(DataType.string, data.freightCharge ? data.freightCharge : '', null, undefined, undefined)
            );
            return new Tbody(rBody, data.orderId, this.openShipment.bind(this));
        });
    }

    openShipment(orderid: string) {
        this.props.history.push('/shipment/' + orderid);
    }

    public render() {
        return (
            <div className="containerfluid">
                <div className="input-group mb-3">
                    <input
                        type="text"
                        className="form-control"
                        value={this.state.searchValue}
                        placeholder="Enter search value"
                        onChange={(e) => this.setSearchData(e.currentTarget.value)}
                        onKeyPress={(event) => {
                            if (event.key === 'Enter') {
                                this.searchData();
                            }
                        }}
                    />
                    <div className="input-group-append">
                        <button className="btn btn-outline-secondary" onClick={(e) => this.searchData()} type="button">
                            Search
                        </button>
                    </div>
                </div>
                <br />
                <div className="tileHead bold">Opportunities ({this.state.opportunities.length})</div>
                {this.state.opportunities.length > 0 ? (
                    <Table
                        tHead={this.state.tableprop.opportunityHead}
                        tBody={this.renderOpportunityBody()}
                        listSize={this.state.opportunities.length}
                        hover={true}
                        cursor={true}
                        hidePagination={true}
                        americanDateFormat={true}
                    />
                ) : (
                    <br />
                )}
                <div className="tileHead bold">Orders ({this.state.orders.length})</div>
                {this.state.orders.length > 0 ? (
                    <Table
                        tHead={this.state.tableprop.orderHead}
                        tBody={this.renderOrderBody()}
                        listSize={this.state.orders.length}
                        hover={true}
                        cursor={true}
                        hidePagination={true}
                        americanDateFormat={true}
                    />
                ) : (
                    <br />
                )}
                <div className="tileHead bold">Shipments ({this.state.shipments.length})</div>
                {this.state.shipments.length > 0 ? (
                    <Table
                        tHead={this.state.tableprop.shipmentHead}
                        tBody={this.renderShipmentBody()}
                        listSize={this.state.shipments.length}
                        hover={true}
                        cursor={true}
                        hidePagination={true}
                        americanDateFormat={true}
                    />
                ) : (
                    <br />
                )}
                <div className="tileHead bold">Invoices ({this.state.invoices.length})</div>
                {this.state.invoices.length > 0 ? (
                    <Table
                        tHead={this.state.tableprop.invoiceHead}
                        tBody={this.renderInvoiceBody()}
                        listSize={this.state.invoices.length}
                        hover={true}
                        cursor={true}
                        hidePagination={true}
                        americanDateFormat={true}
                    />
                ) : (
                    <br />
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): SearchState {
    return {
        shipments: state.shipments,
        header: state.header,
        opportunities: state.opportunities,
        invoices: state.invoices,
        orders: state.order
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): SearchAction {
    return {
        shipmentActions: bindActionCreators(shipmentsActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        opportunitiesActions: bindActionCreators(opportunitiesActionCreators, dispatch),
        invoiceActions: bindActionCreators(invoicesActionCreators, dispatch),
        orderActions: bindActionCreators(orderActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Search)
);



// WEBPACK FOOTER //
// ./src/containers/search/search.tsx